import { render, staticRenderFns } from "./DunningExclusionBuilder.vue?vue&type=template&id=3968955b&"
import script from "./DunningExclusionBuilder.vue?vue&type=script&lang=js&"
export * from "./DunningExclusionBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports